import { tw } from "twind"

export function vehicleMarkerTemplate(data) {

  const title = data.vehicle.plates || data.vehicle.ship_name;
  const subtitle = data.device_info.driver || 'Sem Condutor';
  const stoppedTime = data.device_info.time_stoped;
  const location = '';
  const updatedAt = data.device_info.last_ignition_time;

  const gprsColor = data.device_info.status_entry_1 ? "bg-green-500" : "bg-gray-400"
  const ignitionColor = data.device_info.engine_started ? "text-green-600" : "text-red-600"
  const ignitionText = data.device_info.engine_started ? "Ligada" : "Desligada"
  const gprsText = data.device_info.status_entry_1 ? "GPRS" : "OFF"

  const wrapper = document.createElement("div")
  wrapper.className = tw`
    w-[360px] bg-white rounded-xl shadow-lg
    transform transition-all duration-300 ease-out
    opacity-0 scale-95
  `

  wrapper.innerHTML = `
    <!-- Header -->
    <div class="${tw`flex justify-between items-start pb-4 px-4`}">
      <div class="${tw`min-w-0`}">
        <h3 class="${tw`text-lg font-bold text-gray-900 truncate`}">
          ${title}
        </h3>
        <p class="${tw`text-xs text-gray-500 uppercase tracking-wide truncate`}">
          ${subtitle}
        </p>
      </div>
    </div>

    <!-- Status -->
    <div class="${tw`px-4 pb-2 space-y-2 text-sm text-gray-700`}">
      <div class="${tw`flex justify-between items-center`}">
        <span>${stoppedTime}</span>
        <span class="${tw`flex items-center gap-2`}">
          <span class="${tw`font-semibold`}">${gprsText}</span>
          <span class="${tw`w-2 h-2 rounded-full ${gprsColor}`}"></span>
        </span>
      </div>

      <div class="${tw`flex justify-between items-center`}">
        <span class="${tw`text-gray-500`}">Ignição</span>
        <span class="${tw`font-semibold ${ignitionColor}`}">
          ${ignitionText}
        </span>
      </div>
    </div>

    <!-- Location -->
    <div class="${tw`px-4 py-2 text-sm text-gray-600 flex gap-2`}">
      <svg class="${tw`w-5 h-5 text-gray-400 flex-shrink-0`}"
           viewBox="0 0 24 24" fill="none">
        <path d="M12 21s6-5.686 6-10a6 6 0 10-12 0c0 4.314 6 10 6 10z"
          stroke="currentColor" stroke-width="1.5"/>
        <circle cx="12" cy="11" r="2.5"
          stroke="currentColor" stroke-width="1.5"/>
      </svg>

      <span class="${tw`leading-snug`}">${location}</span>
    </div>

    <div class="${tw`px-4 py-2 text-xs text-gray-400 text-right`}">
      Atualizado: ${updatedAt}
    </div>
  `

  requestAnimationFrame(() => {
    wrapper.classList.remove("opacity-0", "scale-95")
    wrapper.classList.add("opacity-100", "scale-100")
  })

  return wrapper
}

function actionButton(label) {
  return `
    <button class="${tw`p-2 rounded-lg border hover:bg-gray-100 transition`}">
      <span class="${tw`sr-only`}">${label}</span>
      <svg class="${tw`w-5 h-5`}" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9"
          stroke="currentColor" stroke-width="1.5"/>
      </svg>
    </button>
  `
}
